<template>
  <b-row>
    <b-col lg="12">
      <b-card v-if="user.role.code === constants.SOLICITANTE" header="Carga masiva">
        <div class="custom-file form-group">
          <input type="file" class="custom-file-input" v-on:change="onFileChange" id="customFile"/>
          <label class="custom-file-label" for="customFile">Escoge un archivo .csv</label>
        </div>
        <p v-for="(error, k) in errors" :key="k" class="text-danger custom-errors">{{error}}</p>
        <div class="form-group" style="margin-top: 20px;">
          <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
            <i class="icon-arrow-down"></i> Direcciones
          </b-link>
          <b-collapse id="collapse1" invisible>
            <table class="table table-hover table-striped table-bordered">
              <thead>
              <tr>
                <th>Código</th>
                <th>Alias</th>
                <th>Dirección/Zona</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(address, k) in addresses" :key="k">
                <td>{{address.id}}</td>
                <td>{{address.alias}}</td>
                <td>{{address.address}} - {{address.place.name}}</td>
              </tr>
              </tbody>
            </table>
          </b-collapse>
        </div>
        <div class="form-group" style="margin-top: 20px;">
          <b-link class="card-header-action btn-minimize" v-b-toggle.collapse2>
            <i class="icon-arrow-down"></i> Tamaños de contenedores
          </b-link>
          <b-collapse id="collapse2" invisible>
            <table class="table table-hover table-striped table-bordered">
              <thead>
              <tr>
                <th>Código</th>
                <th>Descripción</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(cs, k) in container_sizes" :key="k">
                <td>{{cs.code}}</td>
                <td>{{cs.name}}</td>
              </tr>
              </tbody>
            </table>
          </b-collapse>
        </div>
        <div class="form-group" style="margin-top: 20px;">
          <b-link class="card-header-action btn-minimize" v-b-toggle.collapse3>
            <i class="icon-arrow-down"></i> Tipos de custodia
          </b-link>
          <b-collapse id="collapse3" invisible>
            <table class="table table-hover table-striped table-bordered">
              <thead>
              <tr>
                <th>Código</th>
                <th>Descripción</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(cs, k) in custodies" :key="k">
                <td>{{cs.code}}</td>
                <td>{{cs.name}}</td>
              </tr>
              </tbody>
            </table>
          </b-collapse>
        </div>
        <p>
          <br/>
          <a :href="format_file" target="_blank">
            <i class="fa fa-file"></i> Descargar formato de carga masiva
          </a>
        </p>
      </b-card>
      <b-card header="Pendientes de aprobación">
        <div class="table-responsive rqTable">
          <div class="form-group form-inline pull-right">
            <date-picker v-model="start_date" lang="es" type="date" required format="DD/MM/YYYY"></date-picker>&nbsp;
            <date-picker v-model="end_date" lang="es" type="date" required format="DD/MM/YYYY"></date-picker>&nbsp;
            <button @click="searchByDate()" type="button" class="btn btn-primary">Buscar</button>&nbsp;
            <download-excel
              class="btn btn-primary"
              :data="filteredServices"
              :fields="json_fields"
              name="Pendientes.xls"
            >Descargar Excel
            </download-excel>
          </div>
          <div class="form-group form-inline pull-left">
            <input v-model="search" type="search" class="form-control" placeholder="Buscar..."/> &nbsp;
          </div>
          <table class="table table-striped table-bordered table-hover">
            <thead>
            <tr>
              <th v-if="user.role.code === constants.EJECUTIVO_CUENTA">Cliente</th>
              <th>BL/Booking</th>
              <th>Cantidad de contenedores</th>
              <th>Referencia</th>
              <th>Tipo Servicio</th>
              <th>Línea naviera</th>
              <th>Fecha (cita)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="loading">
              <td colspan="6" align="center">
                <i class="fa fa-lg fa-spinner fa-spin"></i>
              </td>
            </tr>
            <tr
              v-else
              v-for="(service, k) in paginated('filteredServices')"
              @contextmenu.prevent="selectService(service)"
              :key="k"
            >
              <td v-if="user.role.code === constants.EJECUTIVO_CUENTA">
                {{service.company ? service.company.name : ''}}
              </td>
              <td>{{service.doc_number}}</td>
              <td>{{service.requeriments.length}}</td>
              <td>{{service.reference}}</td>
              <td>{{service.service_type.name}}</td>
              <td>{{service.shipping_line ? service.shipping_line.name : ''}}</td>
              <td>{{service.requeriments[0].date | formatDateTime}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <paginate
          name="filteredServices"
          :list="filteredServices"
          class="paginate-list"
          :per="10"
          :refreshCurrentPage="false"
        ></paginate>
        <paginate-links
          for="filteredServices"
          :limit="5"
          :show-step-links="true"
          :step-links="{next: '>>',prev: '<<'}"
          :classes="{'ul': 'pagination','li': 'page-item','a': 'page-link'}"
        ></paginate-links>
        <context-menu id="context-menu" ref="ctxMenu">
          <li v-on:click="editService" class="ctx-item" v-if="!service.service_type.void">Editar</li>
          <li v-on:click="goServiceDetail" class="ctx-item">Detalle</li>
          <li
            v-on:click="removeService"
            class="ctx-item"
            v-if="service.service_type.code === constants.POSICIONAMIENTOS"
          >Eliminar
          </li>
        </context-menu>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
  import api from "@/helpers/api";
  import constants from "@/constants";
  import contextMenu from "vue-context-menu";
  import moment from "moment";
  import {mapGetters} from "vuex";
  import pending from "@/helpers/json_fields/pending";

  export default {
    components: {contextMenu},
    data() {
      return {
        format_file: `${process.env.VUE_APP_SOCKET}formatos/FORMATO_CARGA_MASIVA.xls`,
        services: [],
        service: {service_type: {}},
        constants: {},
        addresses: [],
        container_sizes: [],
        custodies: [],
        paginate: ["filteredServices"],
        start_date: moment().format("YYYY-MM-DD 00:00:00"),
        end_date: moment().format("YYYY-MM-DD 23:59:59"),
        search: "",
        errors: [],
        loading: true,
        json_fields: pending
      };
    },
    mounted() {
      this.constants = constants;
      if (this.user.company_id) {
        api.get(`/company/${this.user.company_id}`).then(response => {
          this.addresses = response.company.addresses;
        });
      }
      api.get("/container_sizes").then(response => {
        this.container_sizes = response.container_sizes;
      });
      api.get("/custodies").then(response => {
        this.custodies = response.custodies;
      });
      this.searchByDate();
    },
    methods: {
      removeService() {
        const {id} = this.service;
        api
          .delete(`/void/${id}`)
          .then(response => {
            const index = this.services.findIndex(ser => ser.id === id);
            this.services.splice(index, 1);
            this.showSuccess("Se elimino el servicio correctamente");
          })
          .catch(err => {
            console.log(err);
            this.showError("No se pudo eliminar el servicio correctamente");
          });
      },
      onFileChange(e) {
        var files = e.target.files || e.dataTransfer.files;
        const permitted_ext = [
          "text/comma-separated-values",
          "text/csv",
          "application/csv",
          "application/excel",
          "application/vnd.ms-excel",
          "application/vnd.msexcel"
        ];
        if (!files.length || !permitted_ext.includes(files[0].type)) {
          this.showError("Formato de archivo inválido.");
        } else {
          const formData = new FormData();
          formData.append("file", files[0]);
          api.post(`/upload_excel`, formData).then(response => {
            const {
              serviceTypeErrors,
              blErrors1,
              blErrors2,
              addressErrors,
              containerErrors,
              chargeTypeErrors,
              totalErrors,
              dateErrors,
              success
            } = response;
            const blErrors = blErrors1.concat(blErrors2);
            if (totalErrors + blErrors.length) {
              if (addressErrors.length)
                this.errors.push(
                  `Filas con error en dirección: ${addressErrors.toString()}`
                );
              if (containerErrors.length)
                this.errors.push(
                  `Filas con error en Tipo de Container: ${containerErrors.toString()}`
                );
              if (dateErrors.length)
                this.errors.push(
                  `Filas con error en Tipo de Container: ${dateErrors.toString()}`
                );
              if (chargeTypeErrors.length)
                this.errors.push(
                  `Filas con error en Tipo de Carga: ${chargeTypeErrors.toString()}`
                );
              if (blErrors.length)
                this.errors.push(
                  `Filas con error en BL/Booking: ${blErrors.toString()}`
                );
              this.showError(
                `No se pudo generar la carga masíva de servicios. Favor, revisar el documento. Lineas con errores: ${totalErrors +
                blErrors.length}`
              );
            } else
              this.showSuccess(
                "Se realizó la carga de servicios, favor actualizar la página para ver los cambios."
              );
          });
        }
      },
      showSuccess(label) {
        this.$toastr.success(label, "Operación exitosa", {
          positionClass: "toast-top-center",
          closeButton: true
        });
      },
      showError(label) {
        this.$toastr.error(label, "Error", {
          positionClass: "toast-top-center",
          closeButton: true
        });
      },
      selectService(service) {
        this.service = service;
        this.$refs.ctxMenu.open();
      },
      editService() {
        // Incorporar logica para validar horario de corte.
        // Esperar respuesta de tramarsa: Kevin
        this.$router.push(`/service/edit/${this.service.id}`);
      },
      goServiceDetail() {
        this.$router.push({
          path: `/services/detail/${this.service.id}`
        });
      },
      searchByDate() {
        if (
          moment(this.start_date).isValid() &&
          moment(this.end_date).isValid()
        ) {
          this.loading = true;
          let data = {
            status_code: [constants.PENDIENTE],
            start_date: moment(this.start_date).format("YYYY-MM-DD 00:00:00"),
            end_date: moment(this.end_date).format("YYYY-MM-DD 23:59:59")
          };
          api.post(`/company_services`, data).then(response => {
            this.services = response.services;
            this.loading = false;
          });
        } else {
          this.$toastr.error(
            `Debes indicar ambas fechas.`,
            "Buscador por fecha",
            {positionClass: "toast-top-center", closeButton: true}
          );
        }
      }
    },
    computed: {
      ...mapGetters({
        user: "user/user"
      }),
      filteredServices() {
        const searchWord = this.search.toLowerCase();
        return this.services.filter(service => {
          let condition = true;
          if (this.search) {

            condition =
              (service.doc_number || "").toLowerCase().includes(searchWord) ||
              (service.reference || "").toLowerCase().includes(searchWord);
          }
          return condition;
        });
      }
    }
  };
</script>
